// extracted by mini-css-extract-plugin
export default {"MicrophoneControl":"_MicrophoneControl--g87Lt","Button":"_Button--pgV9_","MicrophoneIcon":"_MicrophoneIcon--HUt44","VolumeMeter":"_VolumeMeter--wsXpv"};